import React, { useEffect, useState } from 'react';
import * as Rating from '../../Ratings/Ratings';
import { RATING_SMILEY_ID_MAPPING, RATING_TYPES } from '../Constants';
import { TString } from '../../Response/Utils';

import Button from '../../Buttons/Button/Button';
import styled from 'styled-components';
import IconButton from '../../Buttons/IconButton/IconButton';
import Simple from '../../../FeatureComponents/Response/Templates/Simple';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';

const emojiIcons: { colored: string; normal: string; index: number }[] = [];
for (let i = 1; i <= 5; i += 1) {
	emojiIcons.push({
		colored: require(`../../../../../assets/imgs/icons/EmojiIcons/emoji_${i}_color.svg`),
		normal: require(`../../../../../assets/imgs/icons/EmojiIcons/emoji_${i}.svg`),
		index: i - 1,
	});
}

declare var autosubmit;
interface Props {
	primaryColor: string;
	data: any;
	shouldDisableActions: boolean;
	voiceResponse: boolean;
	channel?: string;
	timeStamp?: string;
	langCode?: string;
	handleSubmit?: Function;
}
const TableBox = styled.div`
  .sf-each-summary-table-row {
    border-top: 1px solid
      ${(props: any) => {
				return props.foreground + '4d';
			}};
    }
  .submit{
    border-top: 1px solid
      ${(props: any) => {
				return props.foreground + '4d';
			}};
  }
 
    },
`;
const styleVars = getComputedStyle(document.querySelector(':root'));

const Table = (props: Props) => {
	const [color, setColor] = useState(null);
	const [tableIndex, setIndex] = useState(null);
	const { data, timeStamp } = props;
	const {
		data: {
			table: { tableList, buttons },
		},
		primaryColor,
		shouldDisableActions,
		voiceResponse,
	} = props;
	const setButtonHovered = (foreground, index) => {
		setColor(foreground + '1a');
		setIndex(index);
	};
	const setSpace = (text: string) => {
		let data = text;
		data = data.split(',').join(', ');
		return data;
	};
	let foreground = styleVars.getPropertyValue('--srvMsgColor') || '#ffffff';
	let message = '';
	let valuesArray = [{}];
	const stars = '⭐⭐⭐⭐⭐⭐⭐⭐⭐⭐';
	const getSmiley = (value: string, ratingTypeId: number) => {
		const smileyArray = ['😖', '😞', '😐', '😊', '🤩'];
		if (ratingTypeId === 3) {
			switch (value) {
				case '1':
					return `${smileyArray[0]}`;
				case '2':
					return `${smileyArray[2]}`;
				case '3':
					return `${smileyArray[4]}`;
				default:
					return `${smileyArray[4]}`;
			}
		} else {
			return `${smileyArray[Number(value) - 1]}`;
		}
	};
	const getMessage = (tableList: any) => {
		tableList.map((each) =>
			valuesArray.push({
				heading: each[0].displayText,
				value: each[1].displayText,
				isRatingTask: each[1].isRatingTask,
				ratingTypeId: each[1].ratingTypeId,
			})
		);
		const updatedValues = valuesArray.filter(
			(value) => Object.keys(value).length !== 0
		);

		updatedValues.map((each, index) => {
			message +=
				each['heading'] !== undefined
					? (index === 0 ? '' : '\n') +
					  (index + 1) +
					  '.' +
					  '' +
					  `<b>${each['heading']}</b>` +
					  ' ' +
					  ':' +
					  ' ' +
					  (each['isRatingTask']
							? RATING_SMILEY_ID_MAPPING[each['ratingTypeId']].type ===
							  RATING_TYPES.Star
								? stars.slice(0, each['value']) +
								  '(' +
								  each['value'] +
								  '/' +
								  RATING_SMILEY_ID_MAPPING[each['ratingTypeId']].count +
								  ')'
								: getSmiley(
										each['value'],
										RATING_SMILEY_ID_MAPPING[each['ratingTypeId']].count
								  )
							: each['value']) +
					  '\n'
					: '';
		});
		return message;
	};

	useEffect(() => {
		const keyDownHandler = (event) => {
			if (event.key === 'Enter') {
				if (props.channel === 'whatsapp') {
					const userResponse = loadStateSession('userResp');
					const index = Number(userResponse);
					if (tableList && index && index >= 0 && !shouldDisableActions) {
						props.handleSubmit(tableList[index - 1][2].actionText);
					}
				}
			}
		};

		document.addEventListener('keydown', keyDownHandler);
		return () => {
			document.removeEventListener('keydown', keyDownHandler);
		};
	}, [tableList, props.handleSubmit]);
	return props.channel === 'whatsapp' ? (
		<>
			<div className=' display-msg list-for-whatsapp'>
				<Simple
					data={
						getMessage(tableList) +
						`\n 💡 <b>Tip</b> : To edit any of the above information, please enter its option number. E.g.<i> 1 </i>`
					}
					isRatingTask={false}
					ratingTypeId={0}
					shouldDisableActions={shouldDisableActions}
					langCode={props.langCode}
					timeStamp={timeStamp}
					channel={'whatsapp'}
				/>
			</div>
			<div>
				{buttons.map((eachButton, index) => (
					<div key={index} style={{ marginTop: '4px' }}>
						<Button
							disabled={shouldDisableActions}
							className={`whatsApp-choice-button ${
								shouldDisableActions ? 'disable-confirm-button' : ''
							}`}
							fullWidth={true}
							onClick={() => autosubmit(eachButton.actionText)}
						>
							<span className='btn-text'>{eachButton.displayText}</span>
						</Button>
					</div>
				))}
			</div>
		</>
	) : (
		<div style={props.shouldDisableActions ? { cursor: 'not-allowed' } : {}}>
			<TableBox
				{...{ foreground: foreground }}
				className={`sf-multiple-w mul-sel ${
					shouldDisableActions ? 'action-disabled' : 'msg-bgm'
				}`}
			>
				<div>
					{tableList.map((eachRow, index) => {
						const isRatingTask = eachRow[1].isRatingTask;
						let isStar = false;

						let count;

						if (isRatingTask) {
							count = RATING_SMILEY_ID_MAPPING[eachRow[1].ratingTypeId].count;
							isStar =
								RATING_SMILEY_ID_MAPPING[eachRow[1].ratingTypeId].type ===
								RATING_TYPES.Star;
						}

						return (
							<div
								tabIndex={voiceResponse || shouldDisableActions ? -1 : 0}
								style={{ padding: '16px 12px 16px 16px', cursor: 'default' }}
								className={index !== 0 ? 'sf-each-summary-table-row' : ''}
								key={index}
							>
								<div
									className='row-title overline-text sf-table-text-overflow'
									style={{
										fontWeight: 600,
										marginBottom: isRatingTask ? '4px' : '',
									}}
									title={eachRow[0].displayText}
								>
									{eachRow[0].displayText}
								</div>
								<div className='row-content'>
									<div
										className={`row-text body-text-2 sf-table-text-overflow `}
									>
										{isRatingTask ? (
											isStar ? (
												<Rating.StarRating
													number={count}
													filled={+eachRow[1].displayText}
													onChange={() => {}}
													noLabel
													iconSize={count === 10 ? '16px' : '24'}
													gap={0}
													noOutlineHover
													isClickable={false}
													disable
												/>
											) : (
												<Rating.SmileRating
													number={count}
													filled={+eachRow[1].displayText}
													onChange={() => {}}
													noLabel
													iconSize={'24px'}
													noOutlineHover
													isClickable={false}
													disable
												/>
											)
										) : (
											setSpace(eachRow[1].displayText).replace(
												/<(?!br)([^>]+)>/g, //NOSONAR
												''
											)
										)}
									</div>
									{eachRow[2].actionType === 'QUICKLINK' ? (
										<IconButton
											image='pencil'
											fill={foreground}
											title={TString({ labelName: 'EditLabel' })}
											onClick={() => {
												autosubmit(eachRow[2].actionText);
											}}
											size='large'
											variant='empty'
											disabled={shouldDisableActions}
										/>
									) : (
										<div>{eachRow[2].displayText}</div>
									)}
								</div>
							</div>
						);
					})}
				</div>
				<div>
					{buttons.map((eachButton, index) => (
						<div
							className='submit sbm-btn'
							key={index}
							style={{ color: primaryColor }}
						>
							<Button
								disabled={shouldDisableActions}
								className='submit-btn '
								fullWidth={true}
								onClick={() => autosubmit(eachButton.actionText)}
							>
								<span className='btn-text'>{eachButton.displayText}</span>
							</Button>
						</div>
					))}
				</div>
			</TableBox>
		</div>
	);
};

export default Table;
